import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/DatePicker";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Ruler } from "lucide-react";

export default function RekapUkuran() {
  const [filter, setFilter] = useState({ start: "", end: "", katalog_id: "all" });
  const { data: katalog = [] } = useQuery({ queryKey: ["katalog", "all"], queryFn: async () => (await api.get("/katalog", { params: { include_inactive: true } })).data });
  const params = { start: filter.start || undefined, end: filter.end || undefined, katalog_id: filter.katalog_id === "all" ? undefined : filter.katalog_id };
  const { data: rows = [] } = useQuery({ queryKey: ["rekap-ukuran", params], queryFn: async () => (await api.get("/penjualan/rekap-ukuran", { params })).data });

  const allSizes = (r) => Object.keys(r.sizes).sort();

  return (
    <div className="space-y-5" data-testid="rekap-ukuran">
      <PageHeader icon={Ruler} title="Rekap Ukuran" subtitle="Total item terjual per ukuran untuk tiap produk — bantu keputusan restok." />

      <div className="glass rounded-2xl p-4 flex flex-wrap items-end gap-3">
        <div className="space-y-1"><Label className="text-xs">Dari</Label><DatePicker value={filter.start} testId="rekap-start" onChange={(v) => setFilter({ ...filter, start: v })} className="w-44" /></div>
        <div className="space-y-1"><Label className="text-xs">Sampai</Label><DatePicker value={filter.end} testId="rekap-end" onChange={(v) => setFilter({ ...filter, end: v })} className="w-44" /></div>
        <div className="space-y-1"><Label className="text-xs">Produk</Label>
          <Select value={filter.katalog_id} onValueChange={(v) => setFilter({ ...filter, katalog_id: v })}><SelectTrigger className="w-56" data-testid="rekap-produk-filter"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Semua Produk</SelectItem>{katalog.map((k) => <SelectItem key={k.id} value={k.id}>{k.nama}</SelectItem>)}</SelectContent></Select>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="glass rounded-2xl p-8 text-center text-slate-400">Belum ada penjualan pada periode ini.</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {rows.map((r) => (
            <div key={r.nama} className="glass rounded-2xl p-5" data-testid={`rekap-card-${r.nama}`}>
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-semibold text-emerald-900 dark:text-emerald-100">{r.nama}</h4>
                <span className="text-sm text-emerald-700 dark:text-emerald-400 font-bold">Total {r.total}</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {allSizes(r).map((sz) => (
                  <div key={sz} className="bg-white/60 dark:bg-white/5 rounded-xl px-3 py-2 text-center min-w-[64px]" data-testid={`rekap-${r.nama}-${sz}`}>
                    <p className="text-xs text-slate-500 dark:text-slate-300">{sz}</p>
                    <p className="text-lg font-extrabold text-emerald-800 dark:text-emerald-300">{r.sizes[sz]}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
